/**
 * Generate a 24-character lowercase hex string shaped like a MongoDB
 * ObjectId. Used for client-generated ids on new embedded subdocuments
 * (demographicCategoryConfigs / scoreDefinitions / scoringRules rows,
 * template categoryTemplates rows, etc.) that need a stable id to be
 * cross-referenced (e.g. a scoring rule pointing at a score definition)
 * before the containing document has ever round-tripped through the server.
 * A 24-hex-char string casts cleanly if the server schema types these
 * fields as ObjectId, and works equally well as a plain opaque string id
 * if it doesn't.
 */
export function generateObjectIdLike() {
  const bytes = new Uint8Array(12);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export default { generateObjectIdLike };
